import axios from '../clients/rdn';

export const loadExampleSentences = (word: string) =>
  axios.get(`/words/sentence?word=${word}`);
